import {initializeApp} from "firebase/app";
import {getAuth, GoogleAuthProvider} from "firebase/auth";

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Firebase Auth touches window/indexedDB internally; never initialize it during SSR.
export const auth = import.meta.env.SSR ? undefined : getAuth(initializeApp(firebaseConfig));
export const createGoogleProvider = (emailHint = "") => {
    const provider = new GoogleAuthProvider();
    const trimmedEmailHint = emailHint.trim();

    if (trimmedEmailHint) {
        provider.setCustomParameters({
            login_hint: trimmedEmailHint,
        });
    }

    return provider;
};